export const SucursalesError = [
    { value: "666691" },
    { value: "668820" },
    { value: "668439" },
    { value: "112626" },
    { value: "137517" },
    { value: "668091" },
    { value: "113379" },
    { value: "119855" },
    { value: "29024" },
    { value: "667533" },
    { value: "668329" },
    { value: "669106" },
    { value: "25067" },
    { value: "668605" },
    { value: "667810" },
    { value: "666882" },
    { value: "668859" },
    { value: "667155" },
    { value: "668376" },
    { value: "120138" },
    { value: "668880" },
    { value: "667993" },
    { value: "24939" },
    { value: "106264" },
    { value: "102134" },
    { value: "667452" },
    { value: "666959" },
    { value: "666692" },
    { value: "113245" },
    { value: "668467" },
    { value: "27755" },
    { value: "667862" },
    { value: "115088" },
    { value: "668242" },
    { value: "117658" },
    { value: "117658" },
    { value: "667170" },
    { value: "666723" },
    { value: "668307" },
    { value: "92796" },
    { value: "112435" },
    { value: "136382" },
    { value: "26899" },
    { value: "669125" },
    { value: "123669" },
    { value: "90354" },
    { value: "118773" },
    { value: "132369" },
    { value: "667523" },
    { value: "129404" },
    { value: "95975" },
    { value: "667406" },
    { value: "122760" },
    { value: "122193" },
    { value: "667730" },
    { value: "668369" },
    { value: "122011" },
    { value: "668514" },
    { value: "668656" },
    { value: "668657" },
    { value: "668282" },
    { value: "668799" },
    { value: "99262" },
    { value: "131135" },
    { value: "106249" },
    { value: "25402" },
    { value: "121950" },
    { value: "137613" },
    { value: "116330" },
    { value: "120133" },
    { value: "118781" },
    { value: "667732" },
    { value: "60559" },
    { value: "107227" },
    { value: "107227" },
    { value: "95263" },
    { value: "668667" },
    { value: "668823" },
    { value: "668899" },
    { value: "667890" },
    { value: "129290" },
    { value: "668820" },
    { value: "113330" },
    { value: "89314" },
    { value: "667549" },
    { value: "116332" },
    { value: "666729" },
    { value: "668230" },
    { value: "668797" },
    { value: "107148" },
    { value: "667006" },
    { value: "117821" },
    { value: "129115" },
    { value: "102431" },
    { value: "95560" },
    { value: "668938" },
    { value: "97873" },
    { value: "123875" },
    { value: "668938" },
    { value: "666903" },
    { value: "667753" },
    { value: "667618" },
    { value: "105221" },
    { value: "25510" },
    { value: "668015" },
    { value: "128846" },
    { value: "29582" },
    { value: "112626" },
    { value: "128850" },
    { value: "81255" },
    { value: "112417" },
    { value: "117824" },
    { value: "107158" },
    { value: "114857" },
    { value: "667636" },
    { value: "133850" },
    { value: "666902" },
    { value: "129220" },
    { value: "668879" },
    { value: "667792" },
    { value: "668633" },
    { value: "134044" },
    { value: "108685" },
    { value: "669129" },
    { value: "666695" },
    { value: "669113" },
    { value: "119752" },
    { value: "120414" },
    { value: "668473" },
    { value: "113379" },
    { value: "88369" },
    { value: "28126" },
    { value: "122765" },
    { value: "668909" },
    { value: "667476" },
    { value: "30913" },
    { value: "51904" },
    { value: "669013" },
    { value: "122006" },
    { value: "666723" },
    { value: "102124" },
    { value: "101480" },
    { value: "667277" },
    { value: "668925" },
    { value: "110229" },
    { value: "135625" },
    { value: "126799" },
    { value: "108985" },
    { value: "115501" },
    { value: "117731" },
    { value: "668283" },
    { value: "123767" },
    { value: "111502" },
    { value: "666776" },
    { value: "668807" },
    { value: "115087" },
    { value: "666851" },
    { value: "99805" },
    { value: "131324" },
    { value: "129812" },
    { value: "37377" },
    { value: "668172" },
    { value: "136456" },
    { value: "109984" },
    { value: "119053" },
    { value: "668619" },
    { value: "668319" },
    { value: "667587" },
    { value: "668844" },
    { value: "54049" },
    { value: "138430" },
    { value: "113214" },
    { value: "123646" },
    { value: "129215" },
    { value: "81557" },
    { value: "99269" },
    { value: "107146" },
    { value: "29582" },
    { value: "668522" },
    { value: "117821" },
    { value: "25510" },
    { value: "136089" },
    { value: "668653" },
    { value: "104478" },
    { value: "668263" },
    { value: "128852" },
    { value: "119948" },
    { value: "668437" },
    { value: "129991" },
    { value: "667064" },
    { value: "101481" },
    { value: "667035" },
    { value: "668093" },
    { value: "29306" },
    { value: "667170" },
    { value: "668223" },
    { value: "668767" },
    { value: "106248" },
    { value: "668823" },
    { value: "667720" },
    { value: "119989" },
    { value: "54048" },
    { value: "129404" },
    { value: "667243" },
    { value: "667916" },
    { value: "668075" },
    { value: "25636" },
    { value: "668190" },
    { value: "108690" },
    { value: "666758" },
    { value: "668634" },
    { value: "90353" },
    { value: "666903" },
    { value: "62180" },
    { value: "668305" },
    { value: "101619" },
    { value: "110506" },
    { value: "25513" },
    { value: "667210" },
    { value: "129577" },
    { value: "105440" },
    { value: "666788" },
    { value: "667182" },
    { value: "122997" },
    { value: "90119" },
    { value: "132748" },
    { value: "667581" },
    { value: "101307" },
    { value: "118960" },
    { value: "668739" },
    { value: "113829" },
    { value: "106104" },
    { value: "666815" },
    { value: "120417" },
    { value: "668071" },
    { value: "668762" },
    { value: "667690" },
    { value: "115405" },
    { value: "118764" },
    { value: "93781" },
    { value: "131157" },
    { value: "667322" },
    { value: "103818" },
    { value: "667756" },
    { value: "96049" },
    { value: "667399" },
    { value: "667710" },
    { value: "26321" },
    { value: "667401" },
    { value: "112383" },
    { value: "122770" },
    { value: "667237" },
    { value: "115629" },
    { value: "116193" },
    { value: "668820" },
    { value: "667542" },
    { value: "37371" },
    { value: "668904" },
    { value: "667006" },
    { value: "136382" },
    { value: "106249" },
    { value: "56512" },
    { value: "86651" },
    { value: "100217" },
    { value: "112417" },
    { value: "28270" },
    { value: "28270" },
    { value: "28270" },
    { value: "113592" },
    { value: "131452" },
    { value: "117824" },
    { value: "667991" },
    { value: "668049" },
    { value: "101307" },
    { value: "130645" },
    { value: "137517" },
    { value: "667484" },
    { value: "118773" },
    { value: "667542" },
    { value: "81555" },
    { value: "669155" },
    { value: "666994" },
    { value: "668806" },
    { value: "667584" },
    { value: "667152" },
    { value: "103677" },
    { value: "667187" },
    { value: "123678" },
    { value: "137872" },
    { value: "115629" },
    { value: "666758" },
    { value: "668032" },
    { value: "118764" },
    { value: "25774" },
    { value: "60560" },
    { value: "667678" },
    { value: "137305" },
    { value: "666853" },
    { value: "119053" },
    { value: "667569" },
    { value: "668239" },
    { value: "138432" },
    { value: "28379" },
    { value: "80363" },
    { value: "124003" },
    { value: "106377" },
    { value: "668281" },
    { value: "667237" },
    { value: "667476" },
    { value: "667710" },
    { value: "137972" },
    { value: "667070" },
    { value: "667624" },
    { value: "136816" },
    { value: "135616" },
    { value: "116193" },
    { value: "137262" },
    { value: "100515" },
    { value: "668689" },
    { value: "105899" },
    { value: "132200" },
    { value: "123651" },
    { value: "108985" },
    { value: "37479" },
    { value: "666784" },
    { value: "115405" },
    { value: "668240" },
    { value: "668120" },
    { value: "668603" },
    { value: "666689" },
    { value: "668821" },
    { value: "668420" },
    { value: "668460" },
    { value: "49611" },
    { value: "123257" },
    { value: "118772" },
    { value: "105222" },
    { value: "667543" },
    { value: "136381" },
    { value: "668747" },
    { value: "112317" },
    { value: "103432" },
    { value: "666934" },
    { value: "667430" },
    { value: "115625" },
    { value: "131441" },
    { value: "668528" },
    { value: "138430" },
    { value: "668569" },
    { value: "95263" },
    { value: "111451" },
    { value: "107158" },
    { value: "37376" },
    { value: "667993" },
    { value: "667718" },
    { value: "112435" },
    { value: "87507" },
    { value: "100524" },
    { value: "90884" },
    { value: "132747" },
    { value: "87015" },
    { value: "101544" },
    { value: "668844" },
    { value: "667428" },
    { value: "129290" },
    { value: "27219" },
    { value: "107745" },
    { value: "668699" },
    { value: "81255" },
    { value: "109838" },
    { value: "37892" },
    { value: "667711" },
    { value: "117732" },
    { value: "129207" },
    { value: "668735" },
    { value: "667154" },
    { value: "99130" },
    { value: "136342" },
    { value: "668027" },
    { value: "62180" },
    { value: "668237" },
    { value: "120416" },
    { value: "127375" },
    { value: "97868" },
    { value: "667331" },
    { value: "667730" },
    { value: "666694" },
    { value: "133649" },
    { value: "101300" },
    { value: "668254" },
    { value: "669082" },
    { value: "668771" },
    { value: "667890" },
    { value: "668980" },
    { value: "666856" },
    { value: "134393" },
    { value: "25510" },
    { value: "137983" },
    { value: "134688" },
    { value: "668412" },
    { value: "668952" },
    { value: "137461" },
    { value: "115413" },
    { value: "668642" },
    { value: "26822" },
    { value: "25402" },
    { value: "667401" },
    { value: "668160" },
    { value: "668230" },
    { value: "668942" },
    { value: "119948" },
    { value: "668961" },
    { value: "668645" },
    { value: "668485" },
    { value: "668613" },
    { value: "125165" },
    { value: "668820" },
    { value: "667399" },
    { value: "666903" },
    { value: "27678" },
    { value: "668429" },
    { value: "116156" },
    { value: "668657" },
    { value: "667006" },
    { value: "106249" },
    { value: "668996" },
    { value: "112417" },
    { value: "668003" },
    { value: "114837" },
    { value: "136333" },
    { value: "112384" },
    { value: "98682" },
    { value: "132193" },
    { value: "667299" },
    { value: "122206" },
    { value: "136088" },
    { value: "668945" },
    { value: "668808" },
    { value: "666957" },
    { value: "668844" },
    { value: "122513" },
    { value: "114848" },
    { value: "119240" },
    { value: "668961" },
    { value: "667034" },
    { value: "98737" },
    { value: "668792" },
    { value: "667582" },
    { value: "133649" },
    { value: "119387" },
    { value: "668868" },
    { value: "97871" },
    { value: "27681" },
    { value: "668899" },
    { value: "131319" },
    { value: "668565" },
    { value: "138430" },
    { value: "123669" },
    { value: "136462" },
    { value: "128849" },
    { value: "112321" },
    { value: "120422" },
    { value: "126303" },
    { value: "103679" },
    { value: "100793" },
    { value: "37880" },
    { value: "107736" },
    { value: "668439" },
    { value: "129811" },
    { value: "667277" },
    { value: "106154" },
    { value: "134398" },
    { value: "132799" },
    { value: "27593" },
    { value: "120134" },
    { value: "136797" },
    { value: "668838" },
    { value: "667973" },
    { value: "668525" },
    { value: "115863" },
    { value: "35201" },
    { value: "37080" },
    { value: "669106" },
    { value: "104500" },
    { value: "25636" },
    { value: "25770" },
    { value: "667584" },
    { value: "115101" },
    { value: "668797" },
    { value: "118966" },
    { value: "667326" },
    { value: "95560" },
    { value: "87015" },
    { value: "667830" },
    { value: "668926" },
    { value: "25435" },
    { value: "669233" },
    { value: "668093" },
    { value: "106109" },
    { value: "667467" },
    { value: "122874" },
    { value: "101479" },
    { value: "28270" },
    { value: "667730" },
    { value: "667006" },
    { value: "106249" },
    { value: "61124" },
    { value: "668820" },
    { value: "100791" },
    { value: "667916" },
    { value: "92796" },
    { value: "667636" },
    { value: "666694" },
    { value: "668077" },
    { value: "668453" },
    { value: "98444" },
    { value: "668919" }
];

export default SucursalesError;